<template>
  <div>
    <v-container class="pl-6 pr-6">
      <v-row class="pt-3">
        <v-col class="pb-3">
          <div class="align-center">
            <v-img
                src="../assets/logo.png"
                max-width="80"
            />
          </div>
        </v-col>
        <v-col v-if="this.type === 'month'" cols="auto" class="pb-3" align-self="end">
          <v-row align-content="center">
            <v-col class="pa-0" cols="auto" align-self="center">
              <v-btn fab text small @click="prev" left>
                <v-icon dense>mdi-chevron-left</v-icon>
              </v-btn>
            </v-col>
            <v-col class="pa-0" cols="auto" align-self="center">
              <v-toolbar-title>{{ title }}</v-toolbar-title>
            </v-col>
            <v-col class="pa-0" cols="auto" align-self="center">
              <v-btn fab text small @click="next">
                <v-icon dense>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else class="pb-3" cols="auto" align-self="end">
          <v-btn-toggle v-model="toggleExclusive" dense mandatory borderless>
            <v-btn @click="onClickToggleMonth" small>
              <v-icon small>mdi-calendar-month</v-icon>
            </v-btn>
            <v-btn @click="onClickToggleWeek" small>
              <v-icon small>mdi-view-week-outline</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-col>
      </v-row>
      <v-row class="fill-height pt-1">
        <v-col class="pt-0">
          <v-sheet height="88vh">
            <v-calendar
                ref="calendar"
                v-model="focus"
                :events="events"
                :event-color="getEventColor"
                :event-margin-bottom="2"
                :now="today"
                :type="type"
                @click:event="showEvent"
                @click:more="viewDay"
                @change="updateRange"
                locale="ko"
                :weekdays="[1,2,3,4,5,6]"
                :show-month-on-first="false"
                :light="true"
                :day-format="dayFormat"
                :interval-format="intervalFormat"
            >
              <template v-slot:event="{ event }">
                <div class="v-event-summary" v-html="displayEvent(event)"></div>
              </template>
              <template v-slot:day-label="{ date, day, month, present }">
                <div v-if="isHoliday(date, present)" class="holiday"/>
                <button
                    v-if="present"
                    type="button"
                        class="v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--small transparent::before">
                  <span v-if="day===1" class="v-btn__content">{{ month + '.' + day }}</span>
                  <span v-else class="v-btn__content">{{ day }}</span>
                </button>
                <button
                    v-else
                    type="button"
                    class="v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--small transparent">
                  <span v-if="day===1" class="v-btn__content">{{ month + '.' + day }}</span>
                  <span v-else class="v-btn__content">{{ day }}</span>
                </button>
              </template>
            </v-calendar>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
    <div v-if="this.$store.state.selectedOpen">
      <v-dialog
          :value="this.$store.state.selectedOpen"
          @click:outside="clickOutside"
          @keydown="onKeyDown"
          max-width="600"
      >
        <FormSheet v-bind:event="selectedEvent" :onSucess="getEvents"></FormSheet>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import staticField from '../assets/static'
import FormSheet from './FormSheet';
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import isBetween from 'dayjs/plugin/isBetween'
import Util from '../assets/util'

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);

export default {
  name: 'calendar-main',
  components: {
    FormSheet,
  },
  mounted() {
    setInterval(() => {
      this.getEvents();
      this.today = dayjs(new Date()).tz('Asia/Seoul').format('YYYY-MM-DD');
    }, 5000);
  },
  data: () => ({
    today: dayjs(new Date()).tz('Asia/Seoul').format('YYYY-MM-DD'),
    focus: dayjs(new Date()).tz('Asia/Seoul').format('YYYY-MM-DD'),
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
    },
    name: null,
    details: null,
    start: null,
    end: null,
    color: '#1976D2', // default event color
    currentlyEditing: null,
    selectedEvent: {},
    selectedElement: null,
    events: [],
    holidays: [],
    dialog: false,
    dialogDate: false,
    toggleExclusive: 0
  }),
  computed: {
    title() {
      const {start, end} = this
      if (!start || !end) {
        return ''
      }
      const startMonth = Number.parseInt(this.monthFormatter(start))
      const endMonth = Number.parseInt(this.monthFormatter(end))
      const startYear = start.year
      const endYear = end.year
      const suffixYear = startYear === endYear ? '' : startYear + '.'
      const prefixYear = startYear === endYear ? '' : endYear + '.'
      const startDay = start.day
      const endDay = end.day

      switch (this.type) {
        case 'month':
          return `${startYear}. ${startMonth}.`
        case 'week':
          return `${suffixYear} ${startMonth}. ${startDay} - ${prefixYear} ${endMonth}. ${endDay} `
      }
      return ''
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long',
      })
    },
  },
  methods: {
    async getEvents() {
      const calendarID = staticField.calendarID
      const minTime = dayjs(`${this.start.date} ${this.start.hour}:${this.start.minute}`).subtract(1, 'M').startOf('month').startOf('week').toDate().toISOString()
      const maxTime = dayjs(`${this.start.date} ${this.start.hour}:${this.start.minute}`).add(1, 'M').endOf('month').endOf('week').toDate().toISOString()
      const googleKey = staticField.googleKey

      const {data} = await axios.get(`${process.env.VUE_APP_GOOGLE_API}/calendar/v3/calendars/${calendarID}/events?orderBy=startTime&singleEvents=true&timeMax=${maxTime}&timeMin=${minTime}&key=${googleKey}&fields=items(id,summary,description,start,end)`)
      data.items.map(({description, start, end, id}) => {
        let details;
        let defaultMaxCount = 6;
        const defaultDescription = `{"attendees": [],"maxCount": ${defaultMaxCount}}`;
        details = JSON.parse(defaultDescription);

        if (description) {
          if (Number.parseInt(description)) {
            details.maxCount = Number.parseInt(description);
          } else {
            details = JSON.parse(description);
          }
        }

        const eventName = `(${details.attendees.length}/${details.maxCount})`

        const hourForColor = new Date(start.dateTime).getHours();
        if (!this.events.some(event => event.id === id)) {

          this.events.push({
            name: eventName,
            color: staticField.timeColors[hourForColor - 7],
            start: new Date(start.dateTime),
            end: new Date(end.dateTime),
            timed: true,
            details,
            id,
          });
        } else {
          this.events.filter(event => event.id === id).map(event => {
            event.details = details
            event.name = eventName
          })
        }
      })

      this.events = this.events.filter(event => {
        const searchDates = dayjs(event.start).isBetween(dayjs(minTime), dayjs(maxTime), 'day', '[]');
        return !searchDates || data.items.some(({id}) => id === event.id)
      });
    },
    async getHolidays(year) {

      const existingHolidays = this.$data.holidays

      if (!existingHolidays.some((holidays) => holidays.get('year') === year)) {

        const params = {
          serviceKey: 'uEpTd9Ab9zWw9KVZUDA1LTPEHPI8MQhuXm22dNhJmRm83P8Fr9hFnY9I72h0Vd6e6EGrB3exn9qnPFjOAXFc8g==',
          pageNo: '1',
          numOfRows: '100',
          solYear: year,
          _type: 'json'
        }

        const result = await axios.get('https://apis.data.go.kr/B090041/openapi/service/SpcdeInfoService/getHoliDeInfo', {params})

        const holidays = result.data.response.body.items.item
            .map((item) => dayjs(item.locdate + '', 'YYYYMMDD', 'ASIA/SEOUL', true))
            .filter((holiday) => !existingHolidays.some((existing) => holiday.isSame(existing, 'day')))
        this.$data.holidays = [...this.$data.holidays, ...holidays]
      }

      const dayElements = document.getElementsByClassName('v-calendar-weekly__day-label')

      for (let i = 0; i < dayElements.length; i++) {
        // const buttonElement = dayElements.item(i).getElementsByClassName('v-btn__content')[0]
      }
    },
    viewDay({date}) {
      this.focus = date
      this.type = 'week'
      this.toggleExclusive = 1;
    },
    getEventColor(event) {
      return event.color
    },
    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    showEvent({nativeEvent, event}) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => this.$store.dispatch('setSelectedOpen', true), 10)
      };

      if (this.selectedOpen) {
        this.$store.dispatch('setSelectedOpen', false)
        setTimeout(open, 10)
      } else {
        open()
      }
      nativeEvent.stopPropagation()
    },
    updateRange({start, end}) {
      this.start = start;
      this.end = end;
      console.log(start);
      this.getHolidays(start.year);
      this.getHolidays(start.year + 1);
      this.getHolidays(start.year - 1);
      this.getEvents();
    },
    clickOutside() {
      this.$store.dispatch('setSelectedOpen', false)
    },
    onClickToggleMonth() {
      this.toggleExclusive = 0
      this.type = 'month';
    },
    onClickToggleWeek() {
      this.type = 'week'
      this.toggleExclusive = 1;
    },
    onKeyDown(e) {
      Util.keyDownEventHandler(e, () => this.$store.dispatch('setSelectedOpen', false));
    },
    dayFormat(format) {
      let dayFormat = format.day
      if (format.day === 1) {
        dayFormat = `${format.month}.${format.day}`
      }
      return dayFormat;
    },
    intervalFormat(format) {
      return format.time;
    },
    displayEvent(event) {
      const time = `${dayjs(event.start).format('HH:mm')}`
      const quota = `${event.details.attendees.length}/${event.details.maxCount}`
      return this.type === 'month' ? `<div style="display: inline-block;">${time}</div> <div style="display: inline-block; overflow: no-display">(${quota})</div>` :
          `<div>${time}</div> <div>(${quota})</div>`
    },
    isHoliday(date, present) {
      if (present) {
        return false;
      }
      const dateDayjs = dayjs(date, 'YYYY-MM-DD', 'ASIA/SEOUL');
      return this.$data.holidays.some((holiday) => {
        return dateDayjs.isSame(holiday, 'day')
      })
    }
  }
}
</script>

<style>

.v-event-summary {
  font-size: 11px;
  text-align: center;
  vertical-align: center !important;
}

@media all and (max-width: 396px) {
  .v-event-summary {
    font-size: 10px;
    text-align: center;
    vertical-align: center !important;
  }
}

.v-event.v-event-start.v-event-end.white--text {
  height: 18px !important;
  line-height: 18px !important;
  width: 98% !important;
}

.v-btn.v-btn--fab.v-btn--has-bg.v-btn--round.theme--light.v-size--small {
  height: 20px;
  width: 20px;
}

.v-toolbar__title {
  font-size: 0.9rem !important;
}

.v-btn.v-btn--fab.v-btn--round.v-btn--text.theme--light.v-size--small {
  height: 30px;
  width: 30px;
}

.v-calendar-weekly__day-label .v-btn .v-btn__content {
  letter-spacing: 0;
  font-size: 0.7rem !important;
}

.holiday ~ .v-btn .v-btn__content {
  color: #ff756f;
}

.v-calendar-weekly__day-label {
  margin-top: 0 !important;
  height: 22px;
  line-height: 22px !important;
}

.v-calendar-weekly__head {
  height: 15px;
}

.v-icon.notranslate.v-icon--dense.mdi.theme--light {
  font-size: 18px;
}

.v-application {
  font-family: 'Nunito Sans', sans-serif !important;
}

.theme--light.v-calendar-weekly {
  border-left: none !important;
}

.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-past {
  color: #000000 !important;
}

.theme--light.v-calendar-weekly .v-calendar-weekly__day {
  border-right: none !important;
}

.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {
  border-right: none !important;
}

.v-present .v-btn.v-btn--fab.v-btn--has-bg.v-btn--round.theme--light.v-size--small {
  background-color: #ff756f;
  color: white;
  height: 18px;
  width: 18px;
}

.v-application .transparent {
  color: black !important;
}
</style>
